<template>
  <div>
      <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start; flex-wrap: wrap;">

        <div             
            v-for="(data, index) in image_list"
            :key="index"
            style="display: flex; 
            flex-direction: column; 
            justify-content: center; 
            align-items: center;
            margin: 20px;">
            <div style="width: 200px; height: 200px;">
                <UploadFile 
                    :image_path="data.photo_path"
                    :image_width="200"
                    :file_dialog_id="'customer_profile_order_photo_'+index"
                    :hide_upload="true"
                    :button_style="'width: 100px; top: 5px; position: relative;'"
                />
            </div>
        </div>
        
      </div>
  </div>
</template>

<script>
export default {
    props: ['image_list']
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/CustomerPhotos.vue